var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-container flex-sb"},[_c('div',{staticClass:"content col"},[_c('section',{staticClass:"section"},[(_vm.tabMain['column'])?_c('div',[_c('hospital-health-column',{attrs:{"hospital-id":_vm.hospitalId}})],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }